const convertBase64ToBlob = (base64) => fetch(base64).then((r) => r.blob());

export default convertBase64ToBlob;
